import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import setupSockets from './socketSetup';
import { setCurrentUserId } from '../state/connectionSlice';
import { store } from '../state';

// Define a flag to disable notification features - must match the one in other files
const NOTIFICATIONS_ENABLED = false; // Set to false to disable notifications

/**
 * SocketManager component handles WebSocket initialization and reconnection
 * This should be rendered once in the app, ideally within the authenticated part of the application
 */
const SocketManager = () => {
  const dispatch = useDispatch();
  const { user, token } = useSelector(state => state.auth);
  const userId = user?.id;
  const isAuthenticated = Boolean(token && userId);
  
  useEffect(() => {
    // Skip socket setup if notifications are disabled
    if (!NOTIFICATIONS_ENABLED) {
      console.log('[SocketManager] Notifications are disabled, skipping socket setup');
      return;
    }
    
    let socketCleanup = null;
    
    // Only set up sockets if user is authenticated
    if (isAuthenticated && userId) {
      console.log('[SocketManager] Initializing WebSocket connection for user:', userId);
      
      // Set current user ID in the connection slice to enable proper filtering
      dispatch(setCurrentUserId(userId));
      
      // Initialize socket with store
      socketCleanup = setupSockets(store);
    }
    
    // Clean up socket connection on unmount
    return () => {
      if (socketCleanup) {
        console.log('[SocketManager] Cleaning up WebSocket connection');
        socketCleanup();
      }
    };
  }, [isAuthenticated, userId, dispatch]);
  
  // This component doesn't render anything
  return null;
};

export default SocketManager; 